import { isStatusRefusal, useMemberNotetakerErasure } from './useMemberNotetakerErasure'

import { ErasureStatusState } from '@/api/generated'

interface NotetakerErasureStatusProps {
  userId: string
}

const formatDate = (epochSeconds: number) =>
  new Date(epochSeconds * 1000).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })

const NotetakerErasureStatus = ({ userId }: NotetakerErasureStatusProps) => {
  const { data, error } = useMemberNotetakerErasure(userId)
  if (isStatusRefusal(error)) return null

  let text: string | null = null
  if (data?.state === ErasureStatusState.InFlight) {
    text = 'Deleting Notetaker data. This usually takes about 20 minutes.'
  } else if (data?.state === ErasureStatusState.Completed) {
    text = data.completed_at_epoch_s
      ? `Notetaker data deleted on ${formatDate(data.completed_at_epoch_s)}.`
      : 'Notetaker data deleted.'
  } else if (data?.state === ErasureStatusState.Failed) {
    text = "Couldn't finish deleting Notetaker data. Try again."
  }

  if (!text) return null
  return (
    <p role="status" className="m-0 text-sm leading-5 text-muted-foreground">
      {text}
    </p>
  )
}

export default NotetakerErasureStatus
